// extracted by mini-css-extract-plugin
module.exports = {"overlayClassName":"index_overlayClassName__cGTW5","titleOnly":"index_titleOnly__Hmf5r"};